import type { ComponentType } from 'react';
import type { SectionName } from './lens';
import { OrganizationSection } from './OrganizationSection';
import { UsersSection } from './UsersSection';
import { ComplianceSection } from './ComplianceSection';
import { IntegrationsSection } from './IntegrationsSection';
import { KeysSection } from './KeysSection';
import { TestLabSection } from './TestLabSection';
import { SpendSection } from './SpendSection';
import { TestsSection } from './TestsSection';
import { ScheduleSection } from './ScheduleSection';
import { RetentionSection } from './RetentionSection';
import { ConsentSection, FamilyViewSection, PrefsSection } from './ConsumerSections';
import { TwoFactorSection } from './TwoFactorSection';
import { GuardSection } from './GuardSection';
import { NotificationsSection } from './NotificationsSection';
import { GuardianRulesSection, OnCallSection, VoiceSection } from './RuleSections';
import { DangerZone } from './DangerZone';
import { MyConnectionsSection } from './MyConnectionsSection';
import { AssistantSection } from './AssistantSection';
import { AlertLadderSection } from './AlertLadderSection';
import { BreakGlassSection, ChannelsSection, PilotSection, SurveyorSection } from './V6Sections';
import { MedPassSection } from './MedPassSection';

/** Each section's component, by the design's section name. */
export const SECTIONS: Record<SectionName, ComponentType> = {
  Organization: OrganizationSection,
  'Security & Keys': KeysSection,
  'Two-factor': TwoFactorSection,
  'Guard & Response': GuardSection,
  Notifications: NotificationsSection,
  'On-call': OnCallSection,
  'Guardian rules': GuardianRulesSection,
  'Voice & Scribe': VoiceSection,
  'Data & Retention': RetentionSection,
  'Daily Schedule': ScheduleSection,
  Compliance: ComplianceSection,
  'Models & Spend': SpendSection,
  'Users & Permissions': UsersSection,
  Integrations: IntegrationsSection,
  'Test Lab': TestLabSection,
  Tests: TestsSection,
  'Danger Zone': DangerZone,
  'Your preferences': PrefsSection,
  'Who can see this': ConsentSection,
  'What you can see': FamilyViewSection,
  'My connections': MyConnectionsSection,
  'Atlas Assistant': AssistantSection,
  'Alert ladder': AlertLadderSection,
  'Break-glass': BreakGlassSection,
  Channels: ChannelsSection,
  'Pilot go-live': PilotSection,
  'Surveyor export': SurveyorSection,
  'Med pass': MedPassSection,
};
